/**
 * Ce qu'un rôle donne déjà sur les devis.
 *
 * `admin` et `editor` voient les devis de toute l'équipe ET la vue achat : leur
 * proposer en plus un « profil devis » ne change rien, et un réglage qui
 * n'agit pas se lit comme un réglage cassé. La règle vit ici pour que l'écran
 * qui l'affiche et le serveur qui l'applique ne puissent pas diverger.
 */
export function roleGrantsFullQuoteAccess(role: string | null | undefined): boolean {
  return ['admin', 'editor'].includes(role ?? '');
}
